import { Fab } from "@mui/material";
import { styled as muiStyled } from "@mui/system";

const StyledFab = muiStyled(
  Fab,
  {}
)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    minHeight: "20px",
  },
}));

export { StyledFab };
